import { api } from './api';
import type { WebUser, User } from '../types';

export const usersApi = {
  list: () => api.get<WebUser[]>('/users'),

  // Termin-Übergabe (PR 2, E9): jeder eingeloggte Nutzer darf den Kollegen finden, an den er
  // übergibt — `list` oben ist admin-only. Nur die drei Felder, die eine Auswahlliste braucht.
  teamPicker: () => api.get<{ id: number; username: string; display_name: string | null }[]>('/users/team-picker'),

  create: (data: {
    username: string;
    password: string;
    role?: string;
    lang?: string;
    display_name?: string;
  }) => api.post<WebUser>('/users', data),

  update: (id: number, data: Partial<WebUser & { password?: string }>) =>
    api.patch<WebUser>(`/users/${id}`, data),

  deactivate: (id: number) => api.patch<{ ok: boolean }>(`/users/${id}/deactivate`, {}),

  activate: (id: number) => api.patch<WebUser>(`/users/${id}/activate`, {}),

  resetPassword: (id: number, password: string) =>
    api.patch<WebUser>(`/users/${id}/reset-password`, { password }),

  toggleVideoOutpaint: (id: number, enabled: boolean) =>
    api.patch<WebUser>(`/users/${id}/video-outpaint`, { enabled }),

  impersonate: (id: number) =>
    api.post<{ token: string; user: User }>(`/users/${id}/impersonate`, {}),
};
